@include fade-in;

:host {
  z-index: var(--host-z-index, 0);
  overflow: hidden;
  display: grid;
  grid-template-rows: var(--host-grid-template-rows, 0fr);
  height: 0;
  opacity: var(--host-opacity, 0);
  transition: all 0.3s ease;

  @include media-header('until-md') {
    display: none;
  }

  .container {
    @include media-header('until-md') {
      display: contents;
    }
    @include media-header('from-md') {
      min-height: 0;
    }
  }

  .content {
    display: grid;
    grid-auto-columns: 1fr;
    gap: var-rem(--semantic-spacing-lg);

    @include media-header('from-md') {
      grid-auto-flow: column;
      padding: wink-rem(4) 0 wink-rem(1.6);
    }
  }

  wink-link[appearance='menu-back'] {
    position: sticky;
    top: 0;
    display: block;
    background-color: var(--semantic-components-global-header-color-background-flyout-default);

    @include media-header('from-md') {
      display: none;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      @include state-focus-outline;

      margin: var-rem(--semantic-spacing-2xs);
    }
  }
}

:host([open]) {
  --host-grid-template-rows: 1fr;
  --host-opacity: 1;
  --host-z-index: 1;

  height: auto;

  @include media-header('until-md') {
    display: contents;
  }
}
